import { AnyType } from 'src/globalTypes';

const NotAllowedUploadMessageFromResponse = 'File upload not allowed';

export interface NotAllowedUploadError {
  data: {
    error: string;
  };
}

export const checkIsNotAllowedStatusUploadBody = (
  error: NotAllowedUploadError
): error is NotAllowedUploadError => 'data' in error && 'error' in error.data;

export const getNotAllowedStatusUpload = (error: AnyType | unknown) => {
  const isInstanceNotAllowedUploadMessageFromResponse = checkIsNotAllowedStatusUploadBody(error);

  return isInstanceNotAllowedUploadMessageFromResponse
    ? error.data.error.includes(NotAllowedUploadMessageFromResponse)
    : false;
};
